module.exports = __webpack_public_path__ + "e2dde7c400febb76005c0ddbdcef0b12.png";